import React, { useRef, useState, useEffect } from "react";
import * as BlinkIDSDK from "@microblink/blinkid-in-browser-sdk";
import * as BlinkCardSDK from "@microblink/blinkcard-in-browser-sdk";
import { Box, styled, Typography, useMediaQuery } from '@mui/material'
import Swal from "sweetalert2";
import { ApiKeyMicroblick } from '../utils'
import { HelpDialogBack } from "./HelpDialogBack"

const RootStyle = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

const ScanContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  overflow: "hidden",
  border: "2px solid #999",
  // margin: '1em',
  borderRadius: 12,
  width: "100%",
  height: 300,
  ['@media only screen and (max-width: 812px)']: {
    width: '100%',
    height: '60vh',
  }
}));

const DRIVER_LICENSE = "Licencia de conducir";
const CREDIT_CARD = "Tarjeta de crédito";
const ID = "INE / IFE";
const PASSPORT = "Pasaporte";

export const IdScanMicroBlink = (props) => {
  const matches = useMediaQuery('(max-width:812px)')
  const [scanFeedbackLock, setscanFeedbackLock] = useState(false);
  const [scanTextFeedback, setscanTextFeedback] = useState(
    "Coloca el documento frente a la cámara"
  );
  const [isMovil, setIsMovil] = useState(false);
  const videoRef = useRef();
  const cameraFeedback = useRef();
  const [openHelps, setOpenHelps] = useState(false);

  const getIneData = (data) => {
    // console.log("Extraccion Data INE---***************: ", data)
    const {
      dateOfIssue,
      documentOptionalAdditionalNumber,
      mothersName,
      fathersName,
      documentAdditionalNumber,
      personalIdNumber,
      address,
      dateOfBirth,
      nationality,
      fullName,
      documentNumber,
      classInfo,
      mrz,
      sex,
      dateOfExpiry,
      fullDocumentBackImage,
      fullDocumentFrontImage,
    } = data;
    return {
      metadata: [
        {
          Campo: "MetadataNombre",
          Valor: fullName
        },
        {
          Campo: "MetadataApellidoPaterno",
          Valor: fathersName
        },
        {
          Campo: "MetadataApellidoMaterno",
          Valor: mothersName
        },
        {
          Campo: "MetadataCURP",
          Valor: personalIdNumber
        },
        {
          Campo: "MetadataClaveElector",
          Valor: documentAdditionalNumber
        },
        {
          Campo: "MetadataNúmeroCIC",
          Valor: documentNumber
        },
        {
          Campo: "MetadataNúmeroOCR",
          Valor: mrz.sanitizedOpt1
        },
        {
          Campo: "MetadataAñoEmisión",
          Valor: dateOfIssue.year
        },
        {
          Campo: "MetadataNúmeroEmisión",
          Valor: documentOptionalAdditionalNumber.slice(4)
        },
        {
          Campo: "MetadataAñoRegistro",
          Valor: parseInt(documentOptionalAdditionalNumber.slice(0, 4))
        },
        {
          Campo: "MetadataVigencia",
          Valor: dateOfExpiry?.originalString
        },
        {
          Campo: "MetadataDirección",
          Valor: address
        },
        {
          Campo: "MetadataFechaNacimiento",
          Valor: dateOfBirth?.originalString
        },
      ],
      imageBase64: {
        frente: fullDocumentFrontImage,
        reverso: fullDocumentBackImage,
      },
    };
  };
  const getPassportData = (data) => {
    const {
      lastName,
      personalIdNumber,
      dateOfExpiry,
      dateOfIssue,
      dateOfBirth,
      placeOfBirth,
      mrz,
      nationality,
      firstName,
      documentNumber,
      sex,
      fullDocumentImage,
    } = data;
    return {
      metadata: [
        {
          Campo: "MetadataNombre",
          Valor: firstName
        },
        {
          Campo: "MetadataApellidoPaterno",
          Valor: lastName
        },
        {
          Campo: "MetadataApellidoMaterno",
          Valor: lastName
        },
        {
          Campo: "MetadataCURP",
          Valor: personalIdNumber
        },
        {
          Campo: "MetadataFechaCaducidad",
          Valor: dateOfExpiry?.originalString
        },
        {
          Campo: "MetadataFechaExpedición",
          Valor: dateOfIssue?.originalString
        },
        {
          Campo: "MetadataFechaNacimiento",
          Valor: dateOfBirth?.originalString
        },
        {
          Campo: "MetadataMRZ",
          Valor: mrz?.documentNumber
        },
        {
          Campo: "MetadataNacionalidad",
          Valor: nationality
        },
        {
          Campo: "MetadataPasaporteNo",
          Valor: documentNumber
        },
        {
          Campo: "MetadataSexo",
          Valor: sex
        },
        {
          Campo: "MetadataLugarNacimiento",
          Valor: placeOfBirth
        }
      ],
      imageBase64: fullDocumentImage,
    };
  };
  const getLicenceData = (data) => {
    console.log("Extraccion getLicenceData---***************: ", data)
    const {
      lastName,
      personalIdNumber,
      dateOfExpiry,
      dateOfIssue,
      firstName,
      documentNumber,
      fullDocumentImage,
    } = data;
    return {
      metadata: [
        {
          Campo: "MetadataApellidoMaterno",
          Valor: lastName
        },
        {
          Campo: "MetadataApellidoPaterno",
          Valor: lastName
        },
        {
          Campo: "MetadataCURP",
          Valor: personalIdNumber
        },
        {
          Campo: "MetadataFechaExpedición",
          Valor: dateOfIssue?.originalString
        },
        {
          Campo: "MetadataFechaVencimiento",
          Valor: dateOfExpiry?.originalString
        },
        {
          Campo: "MetadataNombre",
          Valor: firstName
        },
        {
          Campo: "MetadataNúmeroLicencia",
          Valor: documentNumber
        }
      ],
      imageBase64: fullDocumentImage,
    };
  };
  const getCardData = (data) => {
    console.log("Extraccion getCardData---***************: ", data)
    const { owner, cardNumber, expiryDate } = data;
    return {
      metadata: [
        {
          Campo: "MetadataNombre",
          Valor: owner
        },
        {
          Campo: "MetadataNúmeroTarjeta",
          Valor: cardNumber
        },
        {
          Campo: "MetadataVigencia",
          Valor: expiryDate
        },
      ]
    };
  };


  const updateScanFeedback = (message, force) => {
    if (scanFeedbackLock && !force) {
      return;
    }
    setscanFeedbackLock(true);
    setscanTextFeedback(message);
    window.setTimeout(() => setscanFeedbackLock(false), 1000);
  };

  const setupMessage = (displayable) => {
    console.log("status detection: ", displayable.detectionStatus, " - ", displayable)
    switch (displayable.detectionStatus) {
      case BlinkIDSDK.DetectionStatus.Fail:
        updateScanFeedback("Escaneando");
        break;
      case BlinkIDSDK.DetectionStatus.Success:
      case BlinkIDSDK.DetectionStatus.FallbackSuccess:
        updateScanFeedback("Detección correcta");
        break;
      case BlinkIDSDK.DetectionStatus.CameraAtAngle:
        updateScanFeedback("Ajusta el ángulo");
        break;
      case BlinkIDSDK.DetectionStatus.CameraTooHigh:
        updateScanFeedback("Acerca el documento");
        break;
      case BlinkIDSDK.DetectionStatus.CameraTooNear:
      case BlinkIDSDK.DetectionStatus.DocumentTooCloseToEdge:
      case BlinkIDSDK.DetectionStatus.Partial:
        updateScanFeedback("Aleja el documento");
        break;
      default:
        console.warn(
          "Estatus de detección no reconocido",
          displayable.detectionStatus
        );
        updateScanFeedback("Detección no reconocido " + displayable.detectionStatus);
    }
  };

  async function startScanTwoSide(sdk) {
    const combinedGenericIDRecognizer =
      await BlinkIDSDK.createBlinkIdCombinedRecognizer(sdk);
    const currentSetts = await combinedGenericIDRecognizer.currentSettings();
    combinedGenericIDRecognizer.updateSettings({
      ...currentSetts,
      returnEncodedFullDocumentImage: true,
      returnFullDocumentImage: true,
    });

    const callbacks = {
      onQuadDetection: (quad) => setupMessage(quad),
      onDetectionFailed: () => updateScanFeedback("Deteccion fallida", true),
      onFirstSideResult: () => setOpenHelps(true),

      // Swal.fire({
      //   title: "Voltea",
      //   text: "Dale vuelta al documento",
      //   icon: "info",
      // }),
    };

    const recognizerRunner = await BlinkIDSDK.createRecognizerRunner(
      sdk,
      [combinedGenericIDRecognizer],
      false,
      callbacks
    );

    const videoRecognizer =
      await BlinkIDSDK.VideoRecognizer.createVideoRecognizerFromCameraStream(
        videoRef.current,
        recognizerRunner
      );

    const scanTimeoutSeconds = 15;
    videoRecognizer.startRecognition(async (recognitionState) => {
      if (!videoRecognizer) {
        return;
      }
      videoRecognizer.pauseRecognition();
      if (recognitionState === BlinkIDSDK.RecognizerResultState.Empty) {
        return;
      }
      const result = await combinedGenericIDRecognizer.getResult();
      if (result.state === BlinkIDSDK.RecognizerResultState.Empty) {
        return;
      }
      // Swal.fire({
      //   title: "Exito",
      //   text: "Datos leídos correctamente",
      //   icon: "success",
      //   timer: 1200,
      // });
      /* console.log("Resultados BlinkIDCombined", result); */
      props.onGetDocData(getIneData(result));
      videoRecognizer?.releaseVideoFeed();
      recognizerRunner?.delete();
      combinedGenericIDRecognizer?.delete();
    }, scanTimeoutSeconds * 1000).catch((error) => {
      Swal.fire({
        title: "Error",
        text: "No se pudo extraer la información",
        icon: "error",
      });
      console.error(
        "Error durante la inicializacion del VideoRecognizer:",
        error
      );
    });
  }

  async function startScanOneSide(sdk) {
    const genericIDRecognizer = await BlinkIDSDK.createBlinkIdRecognizer(sdk);
    const currentSetts = await genericIDRecognizer.currentSettings();
    genericIDRecognizer.updateSettings({
      ...currentSetts,
      returnEncodedFullDocumentImage: true,
      returnFullDocumentImage: true,
    });
    /* const idBarcodeRecognizer = await BlinkIDSDK.createIdBarcodeRecognizer(sdk); */

    const callbacks = {
      onQuadDetection: (quad) => setupMessage(quad),
      onDetectionFailed: () => updateScanFeedback("Deteccion fallida", true),
    };

    const recognizerRunner = await BlinkIDSDK.createRecognizerRunner(
      sdk,
      [genericIDRecognizer /* idBarcodeRecognizer */],
      false,
      callbacks
    );

    const videoRecognizer =
      await BlinkIDSDK.VideoRecognizer.createVideoRecognizerFromCameraStream(
        videoRef.current,
        recognizerRunner
      );
    const processResult = await videoRecognizer.recognize();
    if (processResult != BlinkIDSDK.RecognizerResultState.Empty) {
      const genericIDResults = await genericIDRecognizer.getResult();
      if (genericIDResults.state != BlinkIDSDK.RecognizerResultState.Empty) {
        // Swal.fire({
        //   title: "Exito",
        //   text: "Datos leídos correctamente",
        //   icon: "success",
        //   timer: 1200,
        // });
        console.log("props.docType------- Scan: ", props.docType);
        if (props.docType === PASSPORT) {
          props.onGetDocData(getPassportData(genericIDResults));
        } else if (props.docType === DRIVER_LICENSE) {
          props.onGetDocData(getLicenceData(genericIDResults));
        }
      }
      /* const idBarcodeResult = await idBarcodeRecognizer.getResult();
      if (idBarcodeResult.state != BlinkIDSDK.RecognizerResultState.Empty) {
        console.log("Resultados IDBracode", idBarcodeResult);
      } */
    } else {
      Swal.fire({
        title: "Error",
        text: "No se pudo extraer la información",
        icon: "error",
      });
    }
    videoRecognizer?.releaseVideoFeed();
    recognizerRunner?.delete();
    genericIDRecognizer?.delete();
    /*  idBarcodeRecognizer?.delete(); */
  }

  const startScanCreditCard = async (sdk) => {
    const blinkCardRecognizer = await BlinkCardSDK.createBlinkCardRecognizer(
      sdk
    );

    const callbacks = {
      onQuadDetection: (quad) => setupMessage(quad),
      onDetectionFailed: () => updateScanFeedback("Deteccion fallida", true),
      onFirstSideResult: () =>
        Swal.fire({
          title: "Voltea",
          text: "Dale vuelta al documento",
          icon: "info",
        }),
    };

    const recognizerRunner = await BlinkCardSDK.createRecognizerRunner(
      sdk,
      [blinkCardRecognizer],
      false,
      callbacks
    );

    const videoRecognizer =
      await BlinkCardSDK.VideoRecognizer.createVideoRecognizerFromCameraStream(
        videoRef.current,
        recognizerRunner
      );
    try {
      const processResult = await videoRecognizer.recognize();

      if (processResult != BlinkCardSDK.RecognizerResultState.Empty) {
        const blinkCardResult = await blinkCardRecognizer.getResult();
        if (
          blinkCardResult.state != BlinkCardSDK.RecognizerResultState.Empty
        ) {
          props.onGetDocData(getCardData(blinkCardResult));
          // Swal.fire({
          //   title: "Exito",
          //   text: "Datos leídos correctamente",
          //   icon: "success",
          //   timer: 1200,
          // });
        }
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "No se pudo extraer la información",
        icon: "error",
      });
      console.error(
        "Error durante la inicializacion del VideoRecognizer:",
        error
      );
      return;
    }

    videoRecognizer?.releaseVideoFeed();

    recognizerRunner?.delete();

    blinkCardRecognizer?.delete();
  };

  const initID = async () => {
    if (!BlinkIDSDK.isBrowserSupported()) {
      Swal.fire({
        title: "Error",
        text: "Navegador no soportado",
        icon: "error",
      });
      return;
    }
    const loadSettings = new BlinkIDSDK.WasmSDKLoadSettings(
      ApiKeyMicroblick.getKey()
    );
    loadSettings.allowHelloMessage = true;
    loadSettings.engineLocation =
      "https://unpkg.com/@microblink/blinkid-in-browser-sdk@5.15.0/resources/";
    try {
      props.setLoadingSDK(true);
      const sdk = await BlinkIDSDK.loadWasmModule(loadSettings);
      props.setLoadingSDK(false);
      props.setSDKSuccess(true);
      console.log("props.docType------- Scan: ", props.docType);
      if (props.docType === PASSPORT || props.docType === DRIVER_LICENSE) {
        startScanOneSide(sdk);
      } else if (props.docType === ID) {
        startScanTwoSide(sdk);
      }
    } catch (err) {
      props.setLoadingSDK(false);
      props.setSDKSuccess(false);
      Swal.fire({
        title: "Error",
        text: "Error al cargar el SDK.",
        icon: "error",
      });
      console.error("Error al cargar el sdk", err);
      setTimeout(function () {
        window.location.reload()
      }, 2000)
    }
  };

  const initCard = async () => {
    if (!BlinkCardSDK.isBrowserSupported()) {
      Swal.fire({
        title: "Error",
        text: "Navegador no soportado",
        icon: "error",
      });
      return;
    }
    const loadSettings = new BlinkCardSDK.WasmSDKLoadSettings(
      ApiKeyMicroblick.getKey()
    );
    loadSettings.allowHelloMessage = true;
    loadSettings.engineLocation =
      "https://unpkg.com/@microblink/blinkcard-in-browser-sdk@2.4.2/resources/";
    try {
      props.setLoadingSDK(true);
      const sdk = await BlinkCardSDK.loadWasmModule(loadSettings);
      props.setLoadingSDK(false);
      props.setSDKSuccess(true);
      startScanCreditCard(sdk);
    } catch (err) {
      props.setLoadingSDK(false);
      props.setSDKSuccess(false);
      Swal.fire({
        title: "Error",
        text: "Error al cargar el SDK.",
        icon: "error",
      });
      console.error("Error al cargar el sdk", err);
      setTimeout(function () {
        window.location.reload()
      }, 2000)
    }
  };

  useEffect(() => {

    if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/Android/i) || matches) {
      setIsMovil(true)
    }
    else {
      setIsMovil(false)
    }

    if (props.docType === CREDIT_CARD) {
      initCard();
    } else {
      initID();
    }
  }, []);

  const handleContinueCapture = () => {
    setOpenHelps(false)
  }

  return (<div style={{ textAlign: 'center' }}>
    <Typography>{scanTextFeedback}</Typography>
    {setIsMovil == false ?
      <ScanContainer>
        <video ref={videoRef} width="100%" height="100%" autoPlay loop muted playsInline></video>
        <canvas ref={cameraFeedback} id="canv" width="100%" ></canvas>
      </ScanContainer> :
      <div>
        {navigator.userAgent.match(/iPhone/i) ?
          <video ref={videoRef} width="100%" height="100%" autoPlay loop muted playsInline></video>
          : <video ref={videoRef} width="100%" height="100%"></video>
        }
        <canvas ref={cameraFeedback} id="canv" width="100%" ></canvas>
      </div>}
    <HelpDialogBack open={openHelps}
      closeAction={() => { setOpenHelps(false) }}
      continueCapture={handleContinueCapture} />
  </div>);
};
